import { render } from "./PriceOverview.vue?vue&type=template&id=67f67078"
import script from "./PriceOverview.vue?vue&type=script&lang=js"
export * from "./PriceOverview.vue?vue&type=script&lang=js"

import "./PriceOverview.vue?vue&type=style&index=0&id=67f67078&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__